import {Button, Grid} from '@mui/material';
import styles from 'assets/jss/AgentStyles/DashboardStyle';
import {digitsEnToFa} from 'persian-tools2';
import {makeStyles} from '@mui/styles';

import EditProfileModal from './EditProfileModal';
import ExitModal from '../Modal/ExitModal';

import DotLoading from 'components/Loading/DotLoading';
import {PRODUCTION_MODE} from 'helpers/Functions';
import useAgentInfo from '../../hooks/useAgentInfo';
import {logoutHandler} from '../../helpers/auth';
import NavCrmButton from 'components/Buttons/NavCrmButton';
import FaqIcon from 'assets/img/faqIcon.svg';
import {detectPathUrl} from '../../helpers/detectPathUrl';

const useStyles = makeStyles(styles);

const Loading = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'left',
    }}>
    <DotLoading width={30} height={20} />
  </div>
);

const AgentAccData = ({handleClose}) => {
  const classes = useStyles();
  const {data, isLoading} = useAgentInfo();

  const {
    city,
    scanCenterAddress,
    phoneNumber,
    firstName,
    isScanCenter,
    lastName,
    scanCenterName,
  } = data || {};

  // scanCenter data
  const scanCenterData = [
    {
      label: 'نام',
      value: `${firstName}`,
    },
    {
      label: 'نام خانوادگی ',
      value: `${lastName}`,
    },
    {
      label: 'شماره موبایل',
      value: phoneNumber,
    },
    {
      label: 'نام مرکز اسکن',
      value: `${scanCenterName}`,
    },
    {label: 'استان', value: city?.province?.name},
    {label: 'شهر', value: city?.name},
    {
      label: 'آدرس',
      value: scanCenterAddress,
    },
  ];
  // is Not scanCener Data
  const notScanCenterData = [
    {
      label: 'شماره موبایل',
      value: phoneNumber,
    },
  ];

  const addressValueLength = scanCenterAddress?.length > 30;

  const mappingData = (value) => {
    return value.map(({value, label}, index) => (
      <Grid key={label} container display='flex'>
        <Grid
          item
          xs={index === 0 ? 4.5 : 4}
          className={classes.rightTitle}
          sx={{
            alignItems: index === scanCenterData.length - 1 && 'flex-start',
          }}>
          {label} :
        </Grid>
        <Grid
          item
          xs={index === 0 ? 7.5 : 8}
          className={classes.leftTitle}
          sx={{
            textAlign:'left'
              // index === scanCenterData.length - 1 && addressValueLength
              //   ? 'right'
              //   : 'left',
          }}>
          {isLoading ? (
            <Loading />
          ) : value ? (
            <span
              style={{
                overflowWrap: 'break-word',
              }}>
              {digitsEnToFa(value)}
            </span>
          ) : (
            <span style={{fontWeight: 400, fontSize: '12px'}}>
              (اطلاعات خود را کامل کنید)
            </span>
          )}
        </Grid>
        {index !== scanCenterData.length - 1 && (
          <div className={classes.dividerStyle} />
        )}
      </Grid>
    ));
  };

  return (
    <Grid container className={classes.accordionData_Container}>
      {mappingData(isScanCenter ? scanCenterData : notScanCenterData)}
      <Grid item xs={6} className={classes.editBtnContainer}>
        <EditProfileModal>
          {!isLoading && (
            <Button className={classes.editBtn} disabled={isLoading}>
              ویرایش اطلاعات
            </Button>
          )}
        </EditProfileModal>
      </Grid>
      <Grid
        item
        xs={6}
        justifyContent='flex-end'
        className={classes.editBtnContainer}>
        <ExitModal logout={logoutHandler}>
          <Button className={classes.exitBtn}>خروج</Button>
        </ExitModal>
      </Grid>
      <div className={classes.dividerStyle} />
      <NavCrmButton
        label='سوالات متداول'
        svg={FaqIcon}
        closeNavHandler={handleClose}
        navigateUrl={detectPathUrl('app/faq')}
      />
    </Grid>
  );
};

export default AgentAccData;
